module.exports = __webpack_public_path__ + "static/media/logo.56f093e4.webp";